import Reflux from 'reflux';
import TeamData from 'shared/data/Team';

const async = { asyncResult: true },
  LabelListActions = Reflux.createActions({
    enableEdit: {},
    cancelEdit: {},
    softDelete: async,
  });

LabelListActions.softDelete.listenAndPromise(TeamData.deleteLabel);

export default LabelListActions;
